// See auth.ts for why the context and hook live apart from the provider.
import { createContext, useContext } from 'react'

export interface EmailContextType {
  email: string
  setEmail: (email: string) => void
  isEmailEntered: boolean
  isEmailValidated: boolean
  setEmailValidated: (validated: boolean) => void
}

export const EmailContext = createContext<EmailContextType | undefined>(undefined)

export const useEmail = () => {
  const context = useContext(EmailContext)
  if (context === undefined) {
    throw new Error('useEmail must be used within an EmailProvider')
  }
  return context
}
